/**
 * Bundle Selector - Cart Integration
 * Handles bundle selection and cart integration
 */

(function() {
  'use strict';

  class BundleCartIntegration {
    constructor() {
      this.selectedVariantId = null;
      this.originalVariantId = null;
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
  const container = document.querySelector('.bundle-upsell-container');
  if (!container) return;

  // get the currently selected option and take its variant id as the "base" variant
  const selectedOption = container.querySelector('.bundle-option.selected');
  if (selectedOption) {
    this.originalVariantId = selectedOption.dataset.variantId;   // <-- variant, not product
    this.selectedVariantId = selectedOption.dataset.variantId;
  }

  this.setupBundleSelection();
  this.interceptFetch();
  this.interceptForm();
  this.wrapMMTrigger();
}

    wrapMMTrigger() {
      const self = this;
      
      // Wrap mmTriggerMainATC
      const wrapTriggerFunction = () => {
        if (typeof window.mmTriggerMainATC !== 'function') {
          setTimeout(wrapTriggerFunction, 100);
          return;
        }
        
        const originalMMTrigger = window.mmTriggerMainATC;
        
        window.mmTriggerMainATC = function() {
          const form = document.querySelector('form[action*="/cart/add"]');
          if (form && self.selectedVariantId) {
            const variantInput = form.querySelector('[name="id"]');
            if (variantInput) {
              variantInput.value = self.selectedVariantId;
            }
          }
          
          return originalMMTrigger.apply(this, arguments);
        };
      };
      
      // Wrap mmAddProductToCart (the actual function that adds to cart)
      const wrapAddFunction = () => {
  if (typeof window.mmAddProductToCart !== 'function') {
    setTimeout(wrapAddFunction, 100);
    return;
  }

  const originalAddToCart = window.mmAddProductToCart;
  const self = this;

  window.mmAddProductToCart = function(variantId, options) {
    // if caller explicitly says "skip bundle", don't touch
    if (options && options.skipBundleSelector) {
      return originalAddToCart.call(this, variantId, options);
    }

    // if we know the original variant AND the caller is adding THAT one,
    // then we can replace with the bundle selection
    if (self.originalVariantId && String(variantId) === String(self.originalVariantId)) {
      const actualVariantId = self.selectedVariantId || variantId;
      return originalAddToCart.call(this, actualVariantId, options);
    }

    // otherwise (different variant = free gift, cart drawer, etc.) → don't touch
    return originalAddToCart.call(this, variantId, options);
  };
};
      
      wrapTriggerFunction();
      wrapAddFunction();
    }

    setupBundleSelection() {
  const options = document.querySelectorAll('.bundle-option');
  const host =
    document.querySelector('[id^="MainProduct-"], section, .product, .product__info-wrapper') || document;

  if (!options.length) return;

  // === ELEMENTS NEAR TITLE ===
  const reduceWrapper   = host.querySelector('.mm-reduce-price');
const titleDiscountEl = reduceWrapper ? reduceWrapper.querySelector('.mm-pink-pill') : null;

// ONLY price elements (exclude compare)
const titlePriceEls   = host.querySelectorAll('.mm-product-price-all:not(.mm-product-compare-at-price)');

// ALL compare-at elements
const titleCompareEls = host.querySelectorAll('.mm-product-compare-at-price');

  // === ATC BUTTONS: main + sticky ===
  const atcButtons = host.querySelectorAll('.mm-main-product-button-container');

  const baseOption = document.querySelector('.bundle-option[data-product-type="single"]');
  const basePriceCents   = baseOption ? Number(baseOption.dataset.price)   : 0;
  const baseCompareCents = baseOption ? Number(baseOption.dataset.compare) : 0;

 function formatMoneyFromCents(cents){
  const amount = cents / 100;
  return amount.toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

  function updateUI(priceCents, compareCents){
    const hasDiscount = compareCents && compareCents > priceCents;
    const diff        = hasDiscount ? (compareCents - priceCents) : 0;
    const pct         = hasDiscount ? Math.round(diff * 100 / compareCents) : 0;

    // 1) Update all current price elements (title + both ATCs)
    titlePriceEls.forEach(el => {
      el.textContent  = formatMoneyFromCents(priceCents);
      el.dataset.value = priceCents;
    });

    // 2) Update all compare-at elements near title
    titleCompareEls.forEach(el => {
      if (hasDiscount) {
        el.textContent  = formatMoneyFromCents(compareCents);
        el.dataset.value = compareCents;
        el.style.display = 'inline';
      } else {
        el.style.display = 'none';
      }
    });

    // 3) Update title discount pill
    if (titleDiscountEl) {
      if (hasDiscount) {
        titleDiscountEl.textContent = `-${pct}%`;
        titleDiscountEl.style.display = 'inline-block';
      } else {
        titleDiscountEl.style.display = 'none';
      }
    }

    // 4) Update ALL ATC buttons (main + sticky)
    atcButtons.forEach(btn => {
      if (!btn) return;

      let reduceEl  = btn.querySelector('.mm-product-price-reduce');
      let percentEl = btn.querySelector('.mm-product-price-percents');

      // If product originally had no discount, create these on demand
      const priceSpan = btn.querySelector('.mm-product-price-all');

      if (!reduceEl && priceSpan) {
        reduceEl = document.createElement('span');
        reduceEl.className = 'mm-product-price-reduce';
        priceSpan.insertAdjacentElement('afterend', reduceEl);
      }

      if (!percentEl && priceSpan) {
        percentEl = document.createElement('div');
        percentEl.className = 'mm-product-price-percents';
        priceSpan.parentNode.insertBefore(
          percentEl,
          priceSpan.nextSibling ? priceSpan.nextSibling.nextSibling : null
        );
      }

      if (!reduceEl || !percentEl) return;

      if (hasDiscount) {
        reduceEl.textContent   = '-' + formatMoneyFromCents(diff);
        reduceEl.style.display = 'inline-block';

        percentEl.textContent   = `-${pct}%`;
        percentEl.style.display = 'block';
      } else {
        reduceEl.style.display  = 'none';
        percentEl.style.display = 'none';
      }
    });
  }

  // INITIAL STATE (single product)
  if (basePriceCents) {
    updateUI(basePriceCents, baseCompareCents);
  }

  // CLICK HANDLERS
  options.forEach(option => {
    option.addEventListener('click', () => {
      options.forEach(o => o.classList.remove('selected', 'bundle-option--selected'));
      option.classList.add('selected', 'bundle-option--selected');

      this.selectedVariantId = option.dataset.variantId;

      const price   = Number(option.dataset.price   || 0);
      const compare = Number(option.dataset.compare || 0);

      updateUI(price, compare);
      this.updateDisplayedPrice(price); // your existing total-price logic (qtty)
    });

    option.setAttribute('tabindex', '0');
    option.setAttribute('role', 'radio');
    option.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        option.click();
      }
    });
  });
}

    interceptFetch() {
  const originalFetch = window.fetch;
  const self = this;

  window.fetch = function(...args) {
    const [url, options] = args;

    const isCartAdd =
      url && (url.includes('/cart/add') || url.toString().includes('/cart/add'));

    if (isCartAdd && self.selectedVariantId && options && options.body) {
      try {
        let body = options.body;

        // JSON body
        if (typeof body === 'string') {
          // if it's a cart drawer / section add → skip
          if (body.includes('"sections"') && body.includes('mm-cart')) {
            return originalFetch.apply(this, args);
          }

          try {
            const bodyData = JSON.parse(body);

            // skip if sections == "mm-cart"
            if (bodyData.sections === 'mm-cart') {
              return originalFetch.apply(this, args);
            }

            if (bodyData.items && bodyData.items[0]) {
              bodyData.items[0].id = parseInt(self.selectedVariantId);
              options.body = JSON.stringify(bodyData);
            } else if (bodyData.id) {
              bodyData.id = parseInt(self.selectedVariantId);
              options.body = JSON.stringify(bodyData);
            }
          } catch (e) {
            // form-encoded
            if (body.includes('id=')) {
              // also skip cart drawer
              if (body.includes('sections=mm-cart')) {
                return originalFetch.apply(this, args);
              }
              const params = new URLSearchParams(body);
              params.set('id', self.selectedVariantId);
              options.body = params.toString();
            }
          }
        }
      } catch (error) {
        console.error('Bundle selector error:', error);
      }
    }

    return originalFetch.apply(this, args);
  };
}

    interceptForm() {
      const form = document.querySelector('form[action*="/cart/add"]');
      
      if (!form) return;
      
      form.addEventListener('submit', () => {
        const variantInput = form.querySelector('[name="id"]');
        if (variantInput && this.selectedVariantId) {
          variantInput.value = this.selectedVariantId;
        }
      }, true);
    }

    updateDisplayedPrice(price) {
  if (!price) return;

  const priceSelectors = [
    '.price__regular .price-item--regular',
    '[data-product-price]',
    '.product__price',
    '.price-item--regular',
    '.price__sale .price-item--sale'
  ];

  priceSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      if (!el.closest('.bundle-option')) {
        el.textContent = this.formatMoney(parseInt(price));
      }
    });
  });
  
  // Update price in add to cart buttons (main and sticky),
  // BUT do NOT touch compare-at elements.
  const ctaPrices = document.querySelectorAll(
    '.mm-product-price-all:not(.mm-product-compare-at-price)'
  );

  ctaPrices.forEach(priceEl => {
    priceEl.textContent  = this.formatMoney(parseInt(price));
    priceEl.dataset.value = price;
  });
}

    formatMoney(cents) {
      const amount = cents / 100;
      
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, Shopify.money_format || '€{{amount}}');
      }
      
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    }
  }

  new BundleCartIntegration();

})();

(function(){
  var bundleOptions = document.querySelectorAll('.bundle-option');
  if (!bundleOptions.length) return;

  // Use first option to find the surrounding product section
  var host = bundleOptions[0].closest('[id^="MainProduct-"], section, .product, .product__info-wrapper') || document;
  var atcButton = host.querySelector('.mm-main-product-button-container'); // your existing ATC button
  if (!atcButton) return;

  // Elements inside the ATC button
  var priceAllEl    = atcButton.querySelector('.mm-product-price-all');
  var priceReduceEl = atcButton.querySelector('.mm-product-price-reduce');
  var percentEl     = atcButton.querySelector('.mm-product-price-percents');

  // Remember original discount text (for reverting to base product if needed)
  var initial = {
    reduceText:  priceReduceEl ? priceReduceEl.textContent : '',
    reduceDisp:  priceReduceEl ? priceReduceEl.style.display : '',
    percentText: percentEl ? percentEl.textContent : '',
    percentDisp: percentEl ? percentEl.style.display : ''
  };

  function formatMoneyFromCents(cents){
    if (!cents || isNaN(cents)) return '';
    var value = cents / 100;
    var s = value.toFixed(2).replace('.', ',');   // 12,34
    s = s.replace(/,00$/, '');                   // remove ,00
    return s + '€';
  }

  function updateDiscountFor(priceCents, compareCents){
    // Ensure discount/percent elements exist
    if (!priceReduceEl && priceAllEl) {
      priceReduceEl = document.createElement('span');
      priceReduceEl.className = 'mm-product-price-reduce';
      priceAllEl.insertAdjacentElement('afterend', priceReduceEl);
    }
    if (!percentEl && priceAllEl) {
      percentEl = document.createElement('div');
      percentEl.className = 'mm-product-price-percents';
      priceAllEl.parentNode.insertBefore(percentEl, priceAllEl.nextSibling.nextSibling || null);
    }

    if (!compareCents || compareCents <= priceCents) {
      if (priceReduceEl) priceReduceEl.style.display = 'none';
      if (percentEl)     percentEl.style.display = 'none';
      return;
    }

    var diff = compareCents - priceCents;
    var pct  = Math.round(diff * 100 / compareCents);

    if (priceReduceEl) {
      priceReduceEl.textContent = '-' + formatMoneyFromCents(diff);
      priceReduceEl.style.display = 'inline-block';
    }
    if (percentEl) {
      percentEl.textContent = '-' + pct + '%';
      percentEl.style.display = 'block';
    }
  }

  function restoreInitialDiscount(){
    if (priceReduceEl) {
      priceReduceEl.textContent = initial.reduceText;
      priceReduceEl.style.display = initial.reduceDisp;
    }
    if (percentEl) {
      percentEl.textContent = initial.percentText;
      percentEl.style.display = initial.percentDisp;
    }
  }

  bundleOptions.forEach(function(option){
    option.addEventListener('click', function(){
      // visual selection, if you want
      bundleOptions.forEach(function(o){ o.classList.remove('bundle-option--selected'); });
      option.classList.add('bundle-option--selected');

      var type    = option.getAttribute('data-product-type') || 'bundle';
      var price   = Number(option.getAttribute('data-price') || 0);
      var compare = Number(option.getAttribute('data-compare') || 0);

      if (type === 'bundle') {
        updateDiscountFor(price, compare);
      } else {
        // e.g. if you have a single-product card with data-product-type="single"
        restoreInitialDiscount();
      }
    });
  });
})();
